




import { TileNotificationsOptions } from '@/utils/TileUtils';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => TileNotificationsOptions,
    },
  },

  beforeMount() {
    this.$emit('input', {});
  },
});
